import { FC, SVGProps } from "react";

const PendingBanner: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentcolor"
      strokeWidth={2}
      strokeLinecap="round"
      {...props}
    >
      <path d="M16.0004 7.99935V16H21.3342M29.3348 16C29.3348 23.3644 23.3648 29.3344 16.0004 29.3344C8.63603 29.3344 2.66602 23.3644 2.66602 16C2.66602 8.6356 8.63603 2.66559 16.0004 2.66559C23.3648 2.66559 29.3348 8.6356 29.3348 16Z" />
    </svg>
  );
};

export default PendingBanner;
